import { render } from "./App.vue?vue&type=template&id=3dcb6f2b"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3dcb6f2b&lang=scss"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_29ac9131eff88fd5e3a0f3b29fc61a57/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__